const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Tracks Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('UserJourneys', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/learn/v3/user-journeys/:subresource/:subsubresource', null, {
    list: {params: {subresource: ''}, method: 'GET', isArray: true},
    get: {params: {subresource: '', subsubresource: ''}, method: 'GET', isArray: false}
  });

}]);
